import * as React from 'react';
import useReduxState from 'src/hooks/useReduxState';

const CheckoutConfirmationPopup = (props) => {
    const { SetStatus } = props;
    const [checkoutClicked, setCheckoutClicked] = useReduxState(false, 'checkoutConfirmation')

    return (
        <div className="avnet-modal modal-630">
        <div className="avnet-modal-inner">
            {/* Modal Header */}
            <button type="button" className="close py-3" data-dismiss="modal"
                onClick={() => SetStatus(false)}
                >×</button>
            <div className="modal-header justify-content-center mt-0">
                <h3 className="pcn-modal-heading pl-5">Request Destination Confirmation</h3>
            </div>
            {/* Modal body */}
            <div className="modal-body">
                <div className="clearfix" />
                <div className="text-center mt-3 mb-5">
                    <p className="mb-0">Are these goods going to Ukraine, Russia, Belarus?</p>
                </div>
            </div>
            {/* Modal footer */}
            <div className="modal-footer text-center">
                <div className="modal-footer-actions">
                    <button type="button" className="bs5 btn btn-secondary btn-sm" data-dismiss="modal"
                        onClick={() => SetStatus(false)}
                        >
                        Yes
                    </button>
                    <button 
                    onClick={() => setCheckoutClicked(true)}
                        type="button" className="bs5 btn btn-primary btn-sm w240">
                        No-Continue to checkout
                    </button>
                </div>
            </div>
        </div>
    </div>
    )

}

export default CheckoutConfirmationPopup